







import {Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class TrackingOrdersChart extends Vue {
  @Prop() series: any [];
  @Prop() title: any;

  get chartOptions() {
    const self = this;
    return {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Tracking Orders, ' + new Date().getFullYear()
      },
      subtitle: {
        text: ''
      },
      accessibility: {
        announceNewData: {
          enabled: true
        }
      },
      xAxis: {
        type: 'category'
      },
      yAxis: {
        title: {
          text: 'Total tracking orders following status'
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: '{point.y:.1f}'
          },
          cursor: 'pointer',
          point: {
            events: {
              click(this: any) {
                self.$router.push({name: 'dashboard.tracking', query: {status: this.options.key}});
              }
            }
          }
        }
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b><br/>'
      },
      series: [{
        name: 'Tracking Orders',
        colorByPoint: true,
        data: this.series
      }]
    };
  }
}
